import { Container } from './styles'
import PropTypes from 'prop-types'
import React from 'react'
import { StageNumber } from '../StageNumber'
import { Typography } from '@taglivros/tag-components'

export function Stage( { number, active, children, completed, ...props } ) {
  return (
    <Container
      active={ active }
      className="stage__number"
      completed={ completed }
      { ...props }
    >
      <StageNumber
        active={ active }
        completed={ completed }
        number={ number }
      />
      <Typography
        color="cinzaMenuSuperiorClaro"
        fontWeight="l"
        variant="text3"
      >
        {children}
      </Typography>
    </Container>
  )
}

Stage.propTypes = {
  'active': PropTypes.bool,
  'children': PropTypes.oneOfType( [
    PropTypes.arrayOf( PropTypes.node ),
    PropTypes.node
  ] ).isRequired,
  'completed': PropTypes.bool,
  'number': PropTypes.number
}

Stage.defaultProps = {
  'active': true,
  'completed': true,
  'number': 1
}
